import PropTypes from 'prop-types'
import React from 'react'
import Input from './Input'
import { Button } from 'components/base'

const InputWithLabelAndButton = ({
  id,
  label,
  inputProps,
  buttonProps,
  buttonLabel,
}) => {
  return (
    <div className="width-full margin-top-small padding-bottom-large  ">
      <label className="bold block margin-bottom-small" htmlFor={id}>
        {label}
      </label>
      <div className="flexbox width-full flexbox-align-center">
        <Input
          id={id}
          type="text"
          className="flexbox-grow margin-right-normal"
          {...inputProps}
        />
        <Button.Primary {...buttonProps}>{buttonLabel}</Button.Primary>
      </div>
    </div>
  )
}

InputWithLabelAndButton.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
}

export default InputWithLabelAndButton
